import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import TabBar from '../../../../../component/tab-bar/tab-bar';
import { AddExamStudentsEligibilityByCourse } from './tabs/add-exam-students-eligibility-by-course';

interface AddEligibilityDialogProps {
  visible: boolean;
  onHide: () => void;
  groupId: number | null;
  examId: number | null;
  onSuccess?: () => void | Promise<void>;
}

const tabs = ['מציאת סטודנטים לפי קורסים'];

export const AddEligibilityDialog: React.FC<AddEligibilityDialogProps> = ({
  visible,
  onHide,
  groupId,
  examId,
  onSuccess,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const tabComponents = [
    <AddExamStudentsEligibilityByCourse
      key="find-by-course"
      groupId={groupId}
      examId={examId}
      onSuccess={async () => {
        if (onSuccess) {
          await onSuccess();
        } else {
          onHide();
        }
      }}
    />,
  ];

  return (
    <Dialog
      header="הוספת זכאות להרשמה"
      visible={visible}
      onHide={onHide}
      style={{
        width: '90%',
        maxWidth: '1400px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
    >
      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedTabIndex(index);
        }}
      />
      <div style={{ marginTop: '20px' }}>{tabComponents[selectedTabIndex]}</div>
    </Dialog>
  );
};
